var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestiicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.751099,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0675F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 42.0844C34.6667 39.9627 33.8239 37.9278 32.3236 36.4276C30.8233 34.9273 28.7885 34.0844 26.6667 34.0844C24.545 34.0844 22.5102 34.9273 21.0099 36.4276C19.5096 37.9278 18.6667 39.9627 18.6667 42.0844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 34.0845C29.6121 34.0845 31.9999 31.6966 31.9999 28.7511C31.9999 25.8056 29.6121 23.4178 26.6666 23.4178C23.7211 23.4178 21.3333 25.8056 21.3333 28.7511C21.3333 31.6966 23.7211 34.0845 26.6666 34.0845Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 42.0845C45.3333 39.9627 44.4904 37.9279 42.9901 36.4276C41.4898 34.9273 39.455 34.0845 37.3333 34.0845C38.7477 34.0845 40.1043 33.5225 41.1045 32.5224C42.1047 31.5222 42.6666 30.1656 42.6666 28.7511C42.6666 27.3366 42.1047 25.9801 41.1045 24.9799C40.1043 23.9797 38.7477 23.4178 37.3333 23.4178",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestiicon2);
export default __webpack_public_path__ + "static/media/destiicon2.1eceda04da05f717efe3a4994a4802b7.svg";
export { ForwardRef as ReactComponent };